import React, { useRef } from "react";
import { format } from "date-fns";
import { formatCurrency } from "../../../utils/formatCurrency";
import { formatDate } from "../../../utils/formatDate";

const TableSalesReport = ({ table }) => {
  //  console.log(table);
  const tableRef = useRef(null);
  const columns = [
    "N°",
    "Imobiliária",
    "Cliente",
    "Data",
    "Q/L",
    "Valor",
    "Status",
  ];

  if (table.sum.signal_total > 0) {
    columns.push("Parcela Sinal");
  }

  if (table.sum.single_total > 0) {
    columns.push("Parcela Unica");
  }

  if (table.sum.entry_total > 0) {
    columns.push("Entrada", "Parcela Entrada", "Qtd Entrada");
  }

  if (table.sum.intermediate_total > 0) {
    columns.push("Intermediária", "Qtd Intermediária");
  }

  if (table.sum.financing_total > 0) {
    columns.push(
      "Financiamento",
      "Taxa",
      "Qtd Parcelas",
      "Val 1°",
      "1º Parcela",
      "Val Últ",
      "Últ Parcela"
    );
  }

  if (table.sum.construction_total > 0) {
    columns.push("Parcela de obra", "Qtd Obra");
  }
  const columnsFiltered = columns.filter((column) => column !== undefined);

  const classpadding = columnsFiltered.length <= 3 ? "p-2" : "p-0";

  const verifyStatus = (status) => {
    switch (status) {
      case 0:
        return (
          <span
            className={"badge bg-warning"}
            style={{
              fontSize: "7px",
            }}
          >
            PA
          </span>
        );
      case 1:
        return (
          <span
            className={"badge bg-danger"}
            style={{
              fontSize: "7px",
            }}
          >
            PR
          </span>
        );
      case 2:
        return (
          <span
            className={"badge bg-success"}
            style={{
              fontSize: "7px",
            }}
          >
            PAP
          </span>
        );
      case 3:
        return (
          <span
            className={"badge bg-info"}
            style={{
              fontSize: "7px",
            }}
          >
            CA
          </span>
        );
      case 4:
        return (
          <span
            className={"badge bg-success"}
            style={{
              fontSize: "7px",
            }}
          >
            CC
          </span>
        );
      case 5:
        return (
          <span
            className={"badge bg-danger"}
            style={{
              fontSize: "7px",
            }}
          >
            CE
          </span>
        );
      case 6:
        return (
          <span
            className={"badge bg-dark"}
            style={{
              fontSize: "7px",
            }}
          >
            CCE
          </span>
        );
      default:
        break;
    }
  };

  return (
    <div className="my-3 d-flex justify-content-center text-center overflow-hidden">
      <table ref={tableRef} style={{ width: "99%" }}>
        <tbody>
          <tr
            className="fw-bolder"
            style={{
              backgroundColor: "#b8b8b8",
              color: "#2D2D2D",
            }}
          >
            {columnsFiltered.map((item, i) => (
              <td
                key={i}
                className="border border-white border-1 p-1 text-center"
                style={{
                  maxWidth: "72px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontSize: "9px",
                }}
              >
                {item}
              </td>
            ))}
          </tr>
          {table &&
            table.data.map((sale, index) => {
              return (
                <tr key={index}>
                  <td
                    className={`text-center border ${classpadding}`}
                    style={{ fontSize: "9px" }}
                  >
                    {sale.id}
                  </td>
                  <td
                    className={`text-center border ${classpadding}`}
                    style={{ fontSize: "9px" }}
                  >
                    {sale.real_estate}
                  </td>
                  <td
                    className={`text-center border ${classpadding}`}
                    style={{ fontSize: "9px" }}
                  >
                    {sale.client.name}
                  </td>
                  <td
                    className={`text-center border ${classpadding}`}
                    style={{ fontSize: "9px" }}
                  >
                    {format(new Date(sale.created_at), "dd/MM/yyyy")}
                  </td>
                  <td
                    className={`text-center border ${classpadding}`}
                    style={{ fontSize: "9px" }}
                  >
                    {sale.block}/{sale.land}
                  </td>
                  <td
                    className={`text-center border ${classpadding}`}
                    style={{ fontSize: "9px" }}
                  >
                    {formatCurrency(sale.sale_value)}
                  </td>
                  <td
                    className={`text-center border ${classpadding}`}
                    style={{ fontSize: "9px" }}
                  >
                    {verifyStatus(sale.status)}
                  </td>
                  {table.sum.signal_total > 0 && (
                    <td
                      className={`text-center border ${classpadding}`}
                      style={{ fontSize: "9px" }}
                    >
                      {formatCurrency(sale.signal_value)}
                    </td>
                  )}
                  {table.sum.single_total > 0 && (
                    <td
                      className={`text-center border ${classpadding}`}
                      style={{ fontSize: "9px" }}
                    >
                      {formatCurrency(sale.single_value)}
                    </td>
                  )}
                  {table.sum.entry_total > 0 && (
                    <>
                      <td
                        className={`text-center border ${classpadding}`}
                        style={{ fontSize: "9px" }}
                      >
                        {formatCurrency(sale.entry_value)}
                      </td>
                      <td
                        className={`text-center border ${classpadding}`}
                        style={{ fontSize: "9px" }}
                      >
                        {formatCurrency(
                          sale.entry_value / sale.number_entry_installments
                        )}
                      </td>
                      <td
                        className={`text-center border ${classpadding}`}
                        style={{ fontSize: "9px" }}
                      >
                        {sale.number_entry_installments}
                      </td>
                    </>
                  )}
                  {table.sum.intermediate_total > 0 && (
                    <>
                      <td
                        className={`text-center border ${classpadding}`}
                        style={{ fontSize: "9px" }}
                      >
                        {formatCurrency(sale.intermediate_value)}
                      </td>
                      <td
                        className={`text-center border ${classpadding}`}
                        style={{ fontSize: "9px" }}
                      >
                        {sale.number_intermediate_installments}
                      </td>
                    </>
                  )}
                  {table.sum.financing_total > 0 && (
                    <>
                      <td
                        className={`text-center border ${classpadding}`}
                        style={{ fontSize: "9px" }}
                      >
                        {formatCurrency(sale.financing_value)}
                      </td>
                      <td
                        className={`text-center border ${classpadding}`}
                        style={{ fontSize: "9px" }}
                      >
                        {sale.financing_rate}%
                      </td>
                      <td
                        className={`text-center border ${classpadding}`}
                        style={{ fontSize: "9px" }}
                      >
                        {sale.number_financing_installments}
                      </td>
                      <td
                        className={`text-center border ${classpadding}`}
                        style={{ fontSize: "9px" }}
                      >
                        {formatCurrency(sale.first_value_financing_installment)}
                      </td>
                      <td
                        className={`text-center border ${classpadding}`}
                        style={{ fontSize: "9px" }}
                      >
                        {formatDate(sale.first_financing_installment)}
                      </td>
                      <td
                        className={`text-center border ${classpadding}`}
                        style={{ fontSize: "9px" }}
                      >
                        {formatCurrency(sale.last_value_financing_installment)}
                      </td>
                      <td
                        className={`text-center border ${classpadding}`}
                        style={{ fontSize: "9px" }}
                      >
                        {formatDate(sale.last_financing_installment)}
                      </td>
                    </>
                  )}
                  {table.sum.construction_total > 0 && (
                    <>
                      <td
                        className={`text-center border ${classpadding}`}
                        style={{ fontSize: "9px" }}
                      >
                        {formatCurrency(sale.construction_value)}
                      </td>
                      <td
                        className={`text-center border ${classpadding}`}
                        style={{ fontSize: "9px" }}
                      >
                        {sale.number_construction_installments}
                      </td>
                    </>
                  )}
                </tr>
              );
            })}
          <tr
            className="fw-bolder"
            style={{ fontSize: "11px", translate: "0px 5px" }}
          >
            <td colSpan={5}>Total Geral</td>
            <td>{formatCurrency(table.sum.sale_total)}</td>
            {table.sum.signal_total > 0 && (
              <td>{formatCurrency(table.sum.signal_total)}</td>
            )}
            {table.sum.single_total > 0 && (
              <td>{formatCurrency(table.sum.single_total)}</td>
            )}
            {table.sum.entry_total > 0 && (
              <td>{formatCurrency(table.sum.entry_total)}</td>
            )}
            <td colSpan={2}></td>
            {table.sum.intermediate_total > 0 && (
              <td>{formatCurrency(table.sum.intermediate_total)}</td>
            )}
            <td></td>
            {table.sum.financing_total > 0 && (
              <td>{formatCurrency(table.sum.financing_total)}</td>
            )}
          </tr>
          <tr
            className="fw-bolder"
            style={{ fontSize: "11px", translate: "0px 2px" }}
          >
            <td colSpan={5}>Total de Registros: {table.reg_total}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TableSalesReport;
